// extracted by mini-css-extract-plugin
module.exports = {"codeBlock":"index_codeBlock_3JgNB"};